define([
    'jquery',
    'globalVars',
    'matchSize',
    'underscore',
    'loadApiMaps',
    'academieUtils',
    'salonsGtm',
    'dadataUtils',
    'salonsState',
    'scrollTo',
], function (
    $,
    { $body, $window, $document },
    matchSize,
    _,
    loadApiMaps,
    academieUtils,
    salonsGtm,
    dadataUtils,
    state,
    scrollTo
) {
    const salonsMap = {
        element: $('#location_map'),

        options: {
            defaultZoom: 12,
            limit: academieUtils.LIMIT,
            persona: {
                validIds: [61740, 92833, 33249, 24036, 64601, 68751, 1135],
                urlParams: {
                    city_slug: 'moscow',
                    country_code: 'ru',
                    chain_slug: 'persona',
                    min_lat: 55.568321,
                    min_lon: 37.336329,
                    max_lat: 55.801074,
                    max_lon: 37.984523,
                },
                boundsOptions: {
                    checkZoomRange: true,
                    zoomMargin: 10,
                },
            },
            searchInputSelector: '#salon-search-input',
        },

        init() {
            if (!this.element.length) {
                return;
            }

            this.initCache();
            this.getPosition();
            salonsGtm.init();
        },

        initCache() {
            this.$searchInput = $(this.options.searchInputSelector);
            this.baloonTemplate = _.template($('#map_baloon_template').html());
        },

        getPosition() {
            dadataUtils
                .getIpLocationRequest()
                .done(this.onIpLocationDone.bind(this))
                .fail(this.onAjaxFail);
        },

        onIpLocationDone(response) {
            if (!response.location) {
                return;
            }

            state.lat = response.location.data.geo_lat;
            state.lng = response.location.data.geo_lon;
            state.city = response.location.data.city;

            window.ymaps.ready(() => {
                this.onYmapsReady();
            });
        },

        onYmapsReady() {
            this.initMap();
            this.createClusterer();

            if (this.isPersonaSalons()) {
                this.loadPersonaSalons();
                return;
            }

            this.loadSalons();

            this.map.events.add('boundschange', () => {
                if (this.map.balloon.isOpen()) {
                    return;
                }

                this.loadSalons();
            });

            this.initSuggest();
        },

        loadPersonaSalons() {
            const url = academieUtils.getSalonsSearchUrl({
                ...this.options.persona.urlParams,
            });

            this.getSalons(url)
                .done(response => {
                    state.salons = this.getSalonsData(
                        response[window.locationKey]
                    );
                    state.salons = state.salons.filter(salon =>
                        this.isValidPersonaSalonId(salon.id)
                    );

                    this.appendPlacemarks();

                    this.map.setBounds(
                        this.map.geoObjects.getBounds(),
                        this.options.persona.boundsOptions
                    );
                })
                .fail(this.onAjaxFail);
        },

        isValidPersonaSalonId(targetId) {
            return this.options.persona.validIds.some(id => id === targetId);
        },

        loadSalons() {
            const url = academieUtils.getSalonsSearchUrl({
                ...this.getMapBoundsObject(),
                city_slug: '',
                city: state.city,
                limit: this.options.limit,
            });

            this.clearMap();

            this.getSalons(url)
                .done(response => {
                    state.salons = this.getSalonsData(
                        response[window.locationKey]
                    );

                    this.appendPlacemarks();
                })
                .fail(this.onAjaxFail);
        },

        getSalons(url) {
            return $.ajax({
                type: 'get',
                url,
                dataType: 'json',
            });
        },

        clearMap() {
            this.clusterer.removeAll();
        },

        onAjaxFail(jqXHR, textStatus, errorThrown) {
            console.error(
                'Sorry, there was an error. Refresh the page and try again' +
                    errorThrown
            );
        },

        initMap() {
            this.map = new ymaps.Map(
                'location_map',
                {
                    center: [state.lat, state.lng],
                    zoom: this.options.defaultZoom,
                    controls: ['zoomControl'],
                    behaviors: ['default'],
                },
                {
                    searchControlProvider: 'yandex#search',
                    suppressMapOpenBlock: true,
                    yandexMapDisablePoiInteractivity: true,
                }
            );

            if (window.isPhone) {
                this.map.behaviors.disable('drag');
            }

            this.map.panes.get('controls')._zIndex = 600;

            this.map.geoObjects.events.add('balloonopen', () => {
                this.showInput(false);
            });
        },

        createClusterer() {
            this.clusterer = new ymaps.Clusterer({
                clusterBalloonContentLayout: 'cluster#balloonCarousel',
                preset: 'islands#blackClusterIcons',
            });

            this.map.geoObjects.add(this.clusterer);
        },

        showInput(isShow) {
            const $closeIcon = this.$searchInput
                .parent()
                .find('.js-clear-input');

            if (isShow) {
                this.$searchInput.fadeIn();
                $closeIcon.fadeIn();
            } else {
                this.$searchInput.fadeOut();
                $closeIcon.fadeOut();
            }
        },

        // on /french-balayage
        isPersonaSalons() {
            return !$('#inputContainer').length;
        },

        appendPlacemarks() {
            state.salons.forEach(item => {
                this.createPlacemark(item);
            });
        },

        createPlacemark(item) {
            const placemark = new ymaps.Placemark(
                [Number(item.geo_lat), Number(item.geo_lon)],
                {
                    balloonContent: this.baloonTemplate(item),
                    preset: 'twirl#blackIcon',
                },
                {
                    iconLayout: 'default#image',
                    iconImageHref: this.element.data('pin-img'),
                    iconImageSize: [30, 30],
                    iconImageOffset: [-15, -30],
                    balloonShadow: false,
                    balloonLayout: this.getBalloonLayout(),
                    balloonContentLayout: this.getBalloonContentLayout(),
                    balloonPanelMaxMapArea: 0,
                }
            );

            this.clusterer.add(placemark);
        },

        getBalloonLayout() {
            const self = this;
            const balloonLayout = ymaps.templateLayoutFactory.createClass(
                `
            <div class="popover top">
                <a class="closeballoon" href="#"></a>
                <div class="arrow"></div>
                $[[options.contentLayout]]
            </div>
            `,
                {
                    build() {
                        this.constructor.superclass.build.call(this);
                        this._$element = $('.popover', this.getParentElement());
                        this.applyElementOffset();
                        this._$element
                            .find('.closeballoon')
                            .on('click', $.proxy(this.onCloseClick, this));
                    },

                    clear() {
                        this._$element.find('.closeballoon').off('click');
                        this.constructor.superclass.clear.call(this);
                    },

                    onSublayoutSizeChange() {
                        balloonLayout.superclass.onSublayoutSizeChange.apply(
                            this,
                            arguments
                        );

                        if (!this._isElement(this._$element)) {
                            return;
                        }

                        this.applyElementOffset();

                        this.events.fire('shapechange');
                    },

                    applyElementOffset() {
                        this._$element.css({
                            left: -(this._$element[0].offsetWidth / 2),
                            top: -(
                                this._$element[0].offsetHeight +
                                this._$element.find('.arrow')[0].offsetHeight
                            ),
                        });
                    },

                    onCloseClick(event) {
                        event.preventDefault();
                        this.events.fire('userclose');

                        self.showInput(true);
                    },

                    getShape() {
                        if (!this._isElement(this._$element)) {
                            return balloonLayout.superclass.getShape.call(this);
                        }

                        const position = this._$element.position();

                        return new ymaps.shape.Rectangle(
                            new ymaps.geometry.pixel.Rectangle([
                                [position.left, position.top],
                                [
                                    position.left +
                                        this._$element[0].offsetWidth,
                                    position.top +
                                        this._$element[0].offsetHeight +
                                        this._$element.find('.arrow')[0]
                                            .offsetHeight,
                                ],
                            ])
                        );
                    },

                    _isElement(element) {
                        return (
                            element && element[0] && element.find('.arrow')[0]
                        );
                    },
                }
            );

            return balloonLayout;
        },

        getBalloonContentLayout() {
            return ymaps.templateLayoutFactory.createClass(
                '<span class="popover-title">$[properties.balloonContent]</span>'
            );
        },

        getYandexGeolocation() {
            const location = ymaps.geolocation.get();

            location.then(
                this.resolveGeoRequest.bind(this),
                this.rejectGeoRequest.bind(this)
            );
        },

        initSuggest() {
            const $inputContainer = $('#inputContainer');
            const $clearInput = $('.js-clear-input');

            if (!this.$searchInput.length) {
                return;
            }

            const unhighlightClass = '_unhighlight-first-suggest-item';
            const hiddenClass = 'hidden';
            const arrowKeyCodes = [38, 40];
            const suggestView = new ymaps.SuggestView(
                this.$searchInput.attr('id')
            );

            $clearInput.on('click', () => {
                this.$searchInput.val('').focus();
            });

            this.$searchInput.on('keyup focusin', ev => {
                if (arrowKeyCodes.indexOf(ev.keyCode) !== -1) {
                    $inputContainer.addClass(unhighlightClass);

                    return;
                }

                if ($(ev.target).val()) {
                    $clearInput.removeClass(hiddenClass);
                } else {
                    $clearInput.addClass(hiddenClass);
                }

                $inputContainer.removeClass(unhighlightClass);

                setTimeout(() => {
                    suggestView.state.set('activeIndex', 0);
                }, 200);
            });

            suggestView.events.add('select', ev => {
                const query = ev.originalEvent.item.displayName;

                $document.triggerHandler('salonLocator:find', ev.originalEvent.item.value);
                suggestView.state.set('request', query);

                ymaps
                    .geocode(query, { result: 1 })
                    .then(this.resolveGeoRequest.bind(this));
            });
        },

        setDataLayer(action, label, event) {
            if (typeof dataLayer !== 'undefined') {
                dataLayer.push({
                    event: event || 'uaevent',
                    eventCategory: 'salon_locator',
                    eventAction: action,
                    eventLabel: label,
                });
            }
        },

        resolveGeoRequest(result) {
            const geoObj = result.geoObjects.get(0);
            const arrPos = geoObj.geometry.getCoordinates();

            this.lat = arrPos[0];
            this.lng = arrPos[1];
            this.city = geoObj.properties._data.name;

            this.map.setCenter(arrPos, this.options.defaultZoom);

            this.clusterer.removeAll();
        },

        getMapBoundsObject() {
            const [[min_lat, min_lon], [max_lat, max_lon]] =
                this.map.getBounds();

            return {
                min_lat,
                min_lon,
                max_lat,
                max_lon,
            };
        },

        getSalonsData(source) {
            return source.map(({ site, phone, socials, ...rest }) => {
                return {
                    site: academieUtils.getSite(site),
                    phone: academieUtils.getPhone(phone),
                    socials: {
                        ...socials,
                        instagram: academieUtils.getInstagram(
                            socials?.instagram
                        ),
                    },
                    ...rest,
                };
            });
        },
    };

    return {
        initialised: false,
        mapApiLoaded: false,

        run() {
            if ($('body').hasClass('cms-salon-search-iframe')) {
                this.initRun();

                return;
            }

            $window.one('scroll', () => {
                this.initRun();
            });
        },

        initRun() {
            if (this.mapApiLoaded) {
                return;
            }

            loadApiMaps(() => this.initMap());

            this.mapApiLoaded = true;
        },

        initMap() {
            if (this.initialised) {
                return;
            }

            salonsMap.init();

            this.initialised = true;
        },
    };
});
